const styles = {
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 36,
    marginBottom: 114,
  },
};

export default styles;
